<template>
    <div class="">
        <banner type="8"></banner>
        <productList :product-list="recommendList" :product-name="$route.query.name"></productList>
    </div>
</template>
<script>
    import productList from "../components/productList";

    export default {
        name: 'recommend',
        components: {
            productList
        },
        data() {
            return {
                recommendList:[]
            }
        },
        mounted() {
            this.getRecommendList()
        },
        methods: {
            async getRecommendList(){
                this.recommendList = await this.$api.getRecommendList({cate_id:this.$route.query.id})
            }
        }
    }
</script>
<style scoped lang="scss">

</style>
